export default __webpack_public_path__ + "static/media/support_platform_mall1.1a61fbad.png";